import { render, staticRenderFns } from "./country.vue?vue&type=template&id=fa3ecf76&scoped=true"
import script from "./country.vue?vue&type=script&lang=js"
export * from "./country.vue?vue&type=script&lang=js"
import style0 from "./country.vue?vue&type=style&index=0&id=fa3ecf76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3ecf76",
  null
  
)

export default component.exports